



































































































import { staffList, autoSearchData } from "@/api/globalSearch";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class extends Vue {
  @Prop() originData!: any[];
  visibilityDialog: boolean = false;
  searchForm: {
    key_word: string;
  } = {
    key_word: "",
  };
  tableData: any = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  selectedList: any = [];
  selectedObject: any = {};
  showDialog() {
    this.visibilityDialog = true;
    this.selectedList = this.originData;
    const obj: any = {};
    this.originData.map((item: any) => {
      obj[item.staff_id] = item;
    });
    this.selectedObject = obj;
    this.getList({
      page: 1,
      page_size: 10,
    });
  }
  getList(val: { page: number; page_size: number }) {
    const option: autoSearchData = {
      page: val.page,
      page_size: val.page_size,
      status: 1,
    };
    if (this.searchForm.key_word) {
      option.key_word = this.searchForm.key_word;
    }
    staffList(option).then((res: any) => {
      if (res.error_code === 0) {
        res.data.list.map((item: any) => {
          if (this.selectedObject[item.staff_id]) {
            item.checked = true;
          } else {
            item.checked = false;
          }
        });
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    });
  }
  handleTeacherSelect(row: any) {
    const copy = { ...this.selectedObject };
    if (copy[row.staff_id]) {
      delete copy[row.staff_id];
    } else {
      copy[row.staff_id] = row;
    }
    this.selectedObject = copy;
    const items = [];
    for (const key in copy) {
      items.push(copy[key]);
    }
    this.selectedList = items;
    const index = this.tableData.findIndex((item: any) => {
      return item.staff_id === row.staff_id;
    });
    if (index >= 0) {
      this.tableData[index].checked = !!copy[row.staff_id];
    }
  }
  handleCancel() {
    this.visibilityDialog = false;
    this.selectedObject = {};
    this.selectedList = [];
    this.searchForm.key_word = "";
    this.page = 1;
    this.pageSize = 10;
  }
  handleConfirm() {
    const ids: number[] = [];
    this.selectedList.map((item: any) => {
      ids.push(Number(item.staff_id));
    });
    this.visibilityDialog = false;
    this.$emit("change", this.selectedList);
  }
  searchChange() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
}
